import { render, staticRenderFns } from "./MyCstmrView.vue?vue&type=template&id=2411b853&"
import script from "./MyCstmrView.vue?vue&type=script&lang=js&"
export * from "./MyCstmrView.vue?vue&type=script&lang=js&"
import style0 from "./MyCstmrView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports